// Product details pages Indonesian translations

export default {
  // Common translations
  products: "PRODUK",
  home: "Beranda",
  productBreadcrumb: "Produk",
  inquireAboutProduct: "Inkuiri Tentang Produk Ini",
  contactUs: "Hubungi Kami",
  contactViaEmail: "Silakan hubungi kami melalui formulir email kami",
  relatedProducts: "Produk Terkait",
  exploreSimilarProducts: "Jelajahi produk serupa lainnya",
  toProductsTop: "Ke Produk TOP",
  productSpecification: "Contoh spesifikasi produk",
  specificationInfo: "Informasi tentang spesifikasi Produk.",
  noteText: "Catatan: Angka di atas menunjukkan kondisi terbaik dalam kasus individual dan mungkin berbeda sesuai dengan ukuran katup dan aplikasi. Hubungi kami sebelum digunakan.",
  productInformation: "Informasi Produk",
  productFeatures: "Fitur Produk",
  featuresDescription: "Fitur utama dari {product}",
  category: "Kategori",
  otherProductsInCategory: "Produk lainnya dalam kategori {category}",
  otherProductsInWaterLubricatedCategory: "Produk lainnya dalam kategori Water Lubricated Stern Tube Bearing",
  machinery: "Mesin",
  application: "Aplikasi",
  function: "Fungsi",
  operatingTemperature: "Suhu Operasional",
  material: "Material",
  applications: "Aplikasi",
  type: "Tipe",
  temperatureRange: "Rentang Suhu",
  maxPressure: "Tekanan Maks",
  volumeRange: "Rentang Volume",
  sealedFluid: "Fluida yang disegel",
  temperature: "Suhu",
  maximumCircumferentialVelocity: "Kecepatan sirkumferensial maksimum",
  pressure: "Tekanan",
  shaftDiameter: "Diameter poros",
  model: "Model",
  benefits: "Manfaat",
  improvedFuelEconomy: "Efisiensi bahan bakar yang lebih baik",
  reducedEmissions: "Emisi yang berkurang",
  enhancedACSystemEfficiency: "Efisiensi sistem AC yang ditingkatkan",
  highEnergyStorageCapacity: "Kapasitas penyimpanan energi tinggi",
  excellentResponseTime: "Waktu respons yang sangat baik",
  lowGasPermeability: "Permeabilitas gas rendah",
  easyMaintenance: "Perawatan mudah",
  longServiceLife: "Masa pakai yang lama",
  wideTemperatureRange: "Rentang suhu yang luas",
  energyStorageInHydraulicSystems: "Penyimpanan energi dalam sistem hidraulik",
  shockAbsorption: "Penyerapan kejut",
  pulsationDampening: "Redam pulsasi",
  emergencyPowerSupply: "Pasokan daya darurat",
  // Additional keys for serviceEngineer-details.js
  serviceType: "Jenis Layanan",
  serviceArea: "Area Layanan",
  responseTime: "Waktu Respons",
  serviceAvailability: "Ketersediaan Layanan",
  specialization: "Spesialisasi",
  serviceCenters: "Pusat Layanan",
  
  // Air Cut Valve
  airCutValve: {
    title: "Air Cut Valve",
    breadcrumb: "Air Cut Valve",
    description1: "Dipasang pada mesin sepeda motor empat tak. Dirancang untuk regulasi emisi gas buang (pasokan udara sekunder).",
    description2: "Air Cut Valve direkayasa dengan presisi untuk memberikan kinerja optimal dalam sistem AC otomotif. Dengan material canggih dan desain inovatif, katup ini memastikan efisiensi maksimal dalam mengontrol perpindahan kompresor sesuai dengan beban A/C, menghasilkan efisiensi bahan bakar yang lebih baik dan emisi yang berkurang.",
    description3: "Air Cut Valve kami menjalani proses kontrol kualitas yang ketat untuk memenuhi standar internasional untuk komponen otomotif. Material khusus yang digunakan dalam manufaktur menawarkan resistensi yang sangat baik terhadap berbagai refrigeran dan minyak kompresor, memastikan masa pakai yang lama bahkan dalam kondisi operasi ekstrem.",
    categoryValue: "Otomotif, Kompresor AC Mobil",
    applicationValue: "Kompresor A/C Perpindahan Variabel",
    functionValue: "Mengontrol sudut swash plate untuk menyesuaikan perpindahan kompresor",
    operatingTemperatureValue: "-40 hingga 150°C",
    materialValue: "Baja tahan karat kelas tinggi dan komponen khusus",
    applicationsValue: "Kompresor AC otomotif untuk kendaraan penumpang dan komersial",
    // Additional keys for airCutValve-details.js
    features: "Fitur",
    featuresSubtitle: "Fitur utama dari Air Cut Valve",
    lightweightAndCompact: "Ringan dan Kompak",
    lightweightAndCompactDescription: "Katup yang ringan dan kompak ini dapat dipasang kembali pada kendaraan yang ada.",
    compositeVersions: "Versi Komposit",
    compositeVersionsDescription: "Kami memenuhi kebutuhan Anda untuk versi komposit, seperti Reed Valve yang digabungkan dengan Cut Valve.",
    otherProductsInAutomobileCategory: "Produk lainnya dalam kategori Otomotif",
    reedValve: "Reed Valve",
    temperature: "Suhu",
    temperatureValue: "-20～120℃",
    vibrationDurability: "Daya tahan getaran",
    vibrationDurabilityValue: "10 G pada suhu ruangan untuk 10^7 siklus"
  },
  
  // Bladder Type Accumulator
  bladderAccumulator: {
    title: "Bladder Type Accumulator",
    breadcrumb: "Bladder Type Accumulator",
    description1: "Akuumulator bladder standar ini diproduksi berdasarkan pengalaman bertahun-tahun dan kinerja yang terbukti. Bladder dapat diganti dan tersedia dalam berbagai ukuran hingga yang berkapasitas besar.",
    description2: "Aplikasi mereka yang luas meliputi mesin industri umum, mesin konstruksi, pembangkit listrik dan pabrik kimia.",
    description3: "",
    categoryValue: "Industri, Komponen Hidraulik",
    typeValue: "Bladder Type Accumulator",
    materialValue: "Cangkang Baja Kelas Tinggi, Bladder Nitrile",
    temperatureRangeValue: "-20°C hingga 120°C",
    maxPressureValue: "Hingga 350 bar",
    volumeRangeValue: "0,5 hingga 50 liter",
    applicationsValue: "Sistem Hidraulik"
  },

  // Bladder Accumulator Features
    bladderFeatures: {
      largeGasVolume: "Volume Gas Besar",
      largeGasVolumeDescription: "Volume gas maksimum yang tersedia adalah 160 L.",
      superiorBladderMaterial: "Material Bladder Superior",
      superiorBladderMaterialDescription: "Bladder yang terbuat dari karet menawarkan resistensi kelelahan tegangan yang sangat baik dan permeabilitas gas yang sangat rendah.",
      highFlowRate: "Laju Aliran Tinggi",
      highFlowRateDescription: "Seri Ultrahigh Flow (UH) disesuaikan untuk laju aliran debit maksimum 4.800 L/menit.",
      complianceWithInternationalStandards: "Kepatuhan dengan Standar Internasional",
      complianceWithInternationalStandardsDescription: "Dapat diatur untuk mematuhi High Pressure Gas Safety Low (Jepang), ASME U Stamp (American Society of Mechanical Engineers), CE Marking (European Pressure Equipment Directive) dan Regulation for Boiler and Pressure Vessel Manufacture Licensing (China).",
      variousComponentsAvailable: "Berbagai Komponen Tersedia",
      variousComponentsAvailableDescription: "Berbagai sambungan cairan (bushing dan flensa), katup utama accumulator, katup kontrol gas, dan perakitan pengisian tersedia.",
      afterSalesSupport: "Dukungan Purnajual",
      afterSalesSupportDescription: "Kami menyediakan layanan pemeliharaan dan dukungan untuk pelanggan kami untuk ketenangan pikiran setelah membeli produk kami.",
      importantNote: "Catatan Penting",
      importantNoteDescription: "* Beberapa model dikecualikan dari persyaratan hukum dan peraturan atau tidak dirancang oleh kami untuk memenuhi persyaratan tersebut."
    },
    
    // Bladder Type Descriptions
    bladderTypeDescriptions: {
      al: "Dengan tipe ini, bladder hanya dapat diganti dari sisi cairan (accumulator perlu dilepas).",
      at: "Tipe ini memungkinkan bladder diganti dari sisi gas atau cairan (dengan accumulator terpasang)."
    },
    
    // Bladder Specification Table
    bladderSpecificationTable: {
      type: "Tipe",
      maxWorkingPressure: "Tekanan Kerja Maks (MPa)",
      nominalGasVolume: "Volume Gas Nominal (L)"
    },

    // Bladder Accumulator specific translations
    bladderFeatures: {
      largeGasVolume: "Volume Gas Besar",
      largeGasVolumeDescription: "Volume gas maksimum yang tersedia adalah 160 L.",
      superiorBladderMaterial: "Material Bladder Superior",
      superiorBladderMaterialDescription: "Bladder yang terbuat dari karet menawarkan resistensi kelelahan tegangan yang sangat baik dan permeabilitas gas yang sangat rendah.",
      highFlowRate: "Laju Aliran Tinggi",
      highFlowRateDescription: "Seri Ultrahigh Flow (UH) disesuaikan untuk laju aliran debit maksimum 4.800 L/menit.",
      complianceWithInternationalStandards: "Kepatuhan dengan Standar Internasional",
      complianceWithInternationalStandardsDescription: "Dapat diatur untuk mematuhi High Pressure Gas Safety Low (Jepang), ASME U Stamp (American Society of Mechanical Engineers), CE Marking (European Pressure Equipment Directive) dan Regulation for Boiler and Pressure Vessel Manufacture Licensing (China).",
      variousComponentsAvailable: "Berbagai Komponen Tersedia",
      variousComponentsAvailableDescription: "Berbagai sambungan cairan (bushing dan flensa), katup utama accumulator, katup kontrol gas, dan perakitan pengisian tersedia.",
      afterSalesSupport: "Dukungan Purnajual",
      afterSalesSupportDescription: "Kami menyediakan layanan pemeliharaan dan dukungan untuk pelanggan kami untuk ketenangan pikiran setelah membeli produk kami.",
      importantNote: "Catatan Penting",
      importantNoteDescription: "* Beberapa model dikecualikan dari persyaratan hukum dan peraturan atau tidak dirancang oleh kami untuk memenuhi persyaratan tersebut."
    },
    bladderTypeDescriptions: {
      al: "Dengan tipe ini, bladder hanya dapat diganti dari sisi cairan (accumulator perlu dilepas).",
      at: "Tipe ini memungkinkan bladder diganti dari sisi gas atau cairan (dengan accumulator terpasang)."
    },
    bladderSpecificationTable: {
      type: "Tipe",
      maxWorkingPressure: "Tekanan Kerja Maks (MPa)",
      nominalGasVolume: "Volume Gas Nominal (L)"
    },
  
  // EH795/EH790 for Water Pump
  eh795: {
    title: "Segel Mekanis untuk Pompa Air EH795/EH790",
    breadcrumb: "Segel Mekanis untuk Pompa Air EH795/EH790",
    description1: "Mampu untuk rotasi kecepatan tinggi. Produksi massal dengan jalur perakitan otomatis penuh dan disuplai ke produsen water pump di seluruh dunia. Dengan desain unitized-nya, EH795 mendukung instalasi yang mudah ke aplikasi pelanggan.",
    categoryValue: "Mechanical Seal, Water Pump",
    modelValue: "EH795/EH790",
    sealedFluidValue: "Air, Pendingin, dll.",
    temperatureValue: "-20°C hingga 110°C (maks. 120°C)",
    maximumCircumferentialVelocityValue: "12 m/s",
    pressureValue: "-67 kPa hingga 0,3 MPaG",
    shaftDiameterValue: "Hingga 30 mm",
    applicationsValue: "Water pump untuk aplikasi otomotif dan industri",
    // Features section
    featuresTitle: "Fitur",
    featuresSubtitle: "Fitur utama dari EH795/EH790 untuk Water Pump",
    highSpeedRotation: "Rotasi Kecepatan Tinggi",
    highSpeedRotationDescription: "Segel ini cocok untuk rotasi kecepatan tinggi karena konstruksinya yang sederhana dan kompak.",
    superiorMaterials: "Material Superior",
    superiorMaterialsDescription: "Material wajah segel terdiri dari komponen karbon dan SiC milik Eagle Industry yang memberikan resistensi tinggi terhadap panas, aus, dan korosi.",
    globalManufacturing: "Manufaktur Global",
    globalManufacturingDescription: "Segel ini diproduksi oleh jalur perakitan otomatis penuh di situs produksi global kami, dan memiliki pangsa pasar tinggi di seluruh dunia khususnya dalam kategori segel untuk water pump otomotif. Segel ini juga cocok untuk pompa industri.",
    unitizedDesign: "Desain Terpadu",
    unitizedDesignDescription: "EH795: Komponen berputar dan stasioner disatukan dengan lengan bermeterai, memberikan kemudahan instalasi serta keandalan tinggi dengan melindungi permukaan geser."
  },
  
  // EVK2RV - Water Lubricated Stern Tube Seal
  evk2rv: {
    title: "Water Lubricated Stern Tube Seal - EVK",
    breadcrumb: "Water Lubricated Stern Tube Seal - EVK",
    description1: "KEMEL memproduksi segel air tipe EVK. Segel tipe EVK memiliki banyak manfaat bagi pemilik dan operator kapal dengan poros berpelumas air. Segel tipe EVK adalah yang termudah dari segel di pasar untuk instalasi dan operasi. Segel tidak mengaus lengan poros baling-baling.",
    description2: "Desain segel tipe EVK KEMEL sangat sederhana. Karena ini adalah segel tipe wajah yang terdiri dari cincin segel dan cincin pasangan, secara fleksibel mengatasi getaran yang rumit dan defleksi poros dan menunjukkan kinerja penyegelan yang sangat baik. Semua perakitan segel disuplai dengan segel aktif dan segel cadangan yang dipasang pada poros siap untuk instalasi.",
    typeValue: "Water Lubricated Stern Tube Seal",
    modelValue: "EVK2RV",
    materialValue: "Komponen Kelautan Kelas Khusus",
    temperatureRangeValue: "-10°C hingga 80°C",
    maxPressureValue: "Hingga 1,0 MPa",
    applicationsValue: "Kapal Maritim, Kapal, Perahu"
  },

  // EVK2RV specific translations
    evk2rvFeatures: {
      excellentSealingPerformance: "1. Kinerja Penyegelan yang Sangat Baik dengan Resistensi Getaran Poros",
      excellentSealingPerformanceDescription: "Karena ini adalah segel tipe ujung wajah yang terdiri dari cincin segel dan cincin pasangan, secara fleksibel mengatasi getaran yang rumit dan defleksi poros dan menunjukkan kinerja penyegelan yang sangat baik.",
      noWearOfShaftSleeve: "2. Tidak ada aus pada lengan poros",
      noWearOfShaftSleeveDescription: "Cincin segel berputar bersama dengan lengan poros dan oleh karena itu, tidak ada aus pada lengan poros. \"Eagle Paint\" disediakan pada permukaan lengan poros untuk mencegah korosi.",
      easyReplacementOfParts: "3. Penggantian Suku Cadang yang Mudah",
      easyReplacementOfPartsDescription: "Cincin segel dan cincin kembung dapat dengan mudah diikat di atas poros oleh vulkanizer. Dengan mengerjakan cincin kembung, inspeksi dan penggantian cincin segel di laut dapat dengan mudah dilakukan.",
      maintenanceSaving: "4. Penghematan Pemeliharaan",
      maintenanceSavingDescription: "Wajah penyegelan cincin segel dan cincin pasangan dilumasi oleh air laut yang datang melalui notch cincin segel, dan oleh karena itu pemeliharaan harian tidak akan diperlukan."
    },
    evk2rvFeaturedDescription: "Segel berpelumas air yang kompak dan berkinerja tinggi yang memiliki resistensi getaran dan kinerja penyegelan yang sangat baik.",
  
  // EVK2RT - Water Lubricated Stern Tube Seal
  evk2rt: {
    title: "Water Lubricated Stern Tube Seal - EVK2RT",
    breadcrumb: "Water Lubricated Stern Tube Seal - EVK2RT",
    description1: "Segel berpelumas air yang kompak dan berkinerja tinggi yang memiliki resistensi getaran dan kinerja penyegelan yang sangat baik. Segel tipe EVK adalah yang termudah dari segel di pasar untuk instalasi dan operasi.",
    description2: "Varian EVK2RT direkayasa untuk aplikasi maritim tertentu yang memerlukan daya tahan dan keandalan yang ditingkatkan. Solusi segel ini memberikan kinerja optimal dalam berbagai kapal maritim dan kondisi operasi.",
    description3: "Dengan material canggih dan manufaktur presisi, segel EVK2RT kami menawarkan resistensi superior terhadap tantangan lingkungan maritim termasuk korosi, aus, dan getaran.",
    spareRingActivation: "Cincin cadangan mudah diaktifkan tanpa membongkar.",
    featuresDescription1: "Fitur aktivasi cincin cadangan cepat untuk downtime minimal dalam operasi maritim. EVK2RT dirancang untuk memberikan kinerja penyegelan yang andal dalam aplikasi stern tube berpelumas air, memastikan perlindungan optimal terhadap masuknya air dan kebocoran oli.",
    featuresDescription2: "Segel EVK2RT kami diproduksi dengan material berkualitas tinggi yang menawarkan resistensi yang sangat baik terhadap lingkungan maritim. Desain inovatif memungkinkan perawatan mudah dan masa pakai yang diperpanjang, mengurangi biaya operasional dan downtime kapal. Mekanisme aktivasi cincin cadangan yang sederhana memungkinkan penggantian cepat tanpa perlu pembongkaran lengkap, menjadikannya solusi ideal untuk kapal maritim yang memerlukan interval perawatan minimal.",
    productInformation: "Informasi Produk",
    category: "Kategori",
    industry: "Industri",
    application: "Aplikasi",
    keyFeature: "Fitur Utama",
    material: "Material",
    benefits: "Manfaat",
    categoryValue: "Segel Maritim",
    industryValue: "Maritim",
    applicationValue: "Stern Tube",
    keyFeatureValue: "Aktivasi cincin cadangan cepat tanpa pembongkaran",
    materialValue: "Komponen tahan laut kelas tinggi",
    benefitsValue: "Downtime minimal, perawatan mudah",
    typeValue: "Water Lubricated Stern Tube Seal",
    modelValue: "EVK2RT",
    temperatureRangeValue: "-10°C hingga 90°C",
    maxPressureValue: "Hingga 1,2 MPa",
    applicationsValue: "Kapal Maritim Komersial, Kapal Industri"
  },

  // EVK2RT specific translations
    evk2rtFeaturedDescription: "Cincin cadangan mudah diaktifkan tanpa membongkar.",
    evk2rtFeatures: {
      improvedWearResistance: "1. Resistensi aus yang ditingkatkan",
      improvedWearResistanceDescription: "Cincin segel aktif #1 selalu dilumasi oleh air tawar bersih yang dikontrol sendiri. Ini menghasilkan pengurangan yang signifikan dalam aus cincin pasangan, perumahan segel, dan cincin segel.",
      builtInSpareSealRing: "2. Cincin segel cadangan terpasang",
      builtInSpareSealRingDescription: "Cincin segel cadangan #2 terpasang dalam perumahan segel sebagai cadangan. Segel #2 siaga dalam kondisi menganggur di bawah operasi normal dan didinginkan, dilumasi & dilindungi oleh air tawar.",
      improvedOperability: "3. Operabilitas yang ditingkatkan",
      improvedOperabilityDescription: "Cincin segel aktif mudah diubah dari #1 ke segel cadangan #2 dengan operasi katup. Segel cadangan #2 diaktifkan tanpa membongkar unit segel seharusnya cincin segel #1 menunjukkan kebocoran yang meningkat.",
      easyUpgradeFromExistingEVK: "4. Peningkatan mudah dari EVK yang ada",
      easyUpgradeFromExistingEVKDescription: "Dengan mengganti perumahan segel, mungkin untuk mengkonversi segel EVK yang ada ke tipe Tandem."
    },
    evk2rtSpecificationTable: {
      shaftDiameterRange: "Rentang diameter poros",
      pvValue: "Nilai PV (Tekanan-Velocity)"
    },
  
  // EVR - Water Lubricated Stern Tube Bearing
  evr: {
    title: "Water Lubricated Stern Tube Bearing - EVR",
    breadcrumb: "Water Lubricated Stern Tube Bearing - EVR",
    description1: "Daya Tahan dan Penyerapan Getaran yang Sangat Baik.",
    description2: "Kombinasi keunggulan plastik yang diperkuat dengan elastomer, Daya tahan yang luar biasa dan kinerja yang stabil, Penyerapan getaran poros yang efektif, Pencegahan Korosi Elektrolitik pada lengan poros",
    description3: "Bantalan Tipe Lurus, cangkang luar terbuat dari Plastik Berlapis Kain Katun (CRP) yang diresapi dengan termosetting. Cocok untuk dipasang pada kapal dengan diameter relatif kecil. Bantalan Tipe Flensa, cangkang luar terbuat dari Plastik Berlapis Kain Kaca (GRP), dan cocok untuk diameter relatif lebih besar.",
    categoryValue: "Maritim, Bantalan Berpelumas Air",
    typeValue: "Water Lubricated Stern Tube Bearing",
    modelValue: "EVR",
    materialValue: "Material Bantalan Berpelumas Air Khusus",
    temperatureRangeValue: "-5°C hingga 70°C",
    maxPressureValue: "Hingga 2,0 MPa",
    applicationsValue: "-",
    // EVR specific translations
    featuredDescription: "Daya Tahan dan Penyerapan Getaran yang Sangat Baik.",
    features: "Fitur",
    featuresSubtitle: "Fitur utama dan manfaat dari EVR",
    combinationOfAdvantages: "1. Kombinasi keunggulan plastik yang diperkuat dengan elastomer",
    combinationOfAdvantagesDescription: "Memanfaatkan sifat terbaik dari material plastik yang diperkuat dan elastomer untuk kinerja optimal.",
    outstandingDurability: "2. Daya tahan yang luar biasa dan kinerja yang stabil",
    outstandingDurabilityDescription: "Direkayasa untuk memberikan layanan tahan lama dengan kinerja konsisten di bawah berbagai kondisi laut.",
    effectiveAbsorption: "3. Penyerapan getaran poros yang efektif",
    effectiveAbsorptionDescription: "Menyerap dan meredam getaran poros secara efektif, mengurangi stres pada sistem bantalan.",
    preventionOfCorrosion: "4. Pencegahan Korosi Elektrolitik pada lengan poros",
    preventionOfCorrosionDescription: "Desain khusus mencegah korosi elektrolitik, memperpanjang umur lengan poros.",
    types: "Tipe",
    typesSubtitle: "Tipe bantalan EVR yang tersedia untuk berbagai aplikasi",
    straightTypeBearing: "1. Bantalan Tipe Lurus",
    straightTypeBearingDescription: "Cangkang luar terbuat dari Plastik Berlapis Kain Katun (CRP) yang diresapi dengan resin termosetting. Cocok untuk dipasang pada kapal dengan diameter relatif kecil.",
    flangeTypeBearing: "2. Bantalan Tipe Flensa",
    flangeTypeBearingDescription: "Cangkang luar terbuat dari Plastik Berlapis Kain Kaca (GRP), dan cocok untuk diameter yang relatif lebih besar.",
    specifications: "Spesifikasi",
    specificationsSubtitle: "Spesifikasi teknis dari Bantalan Stern Tube Berpelumas Air EVR",
    sizeRange: "Rentang Ukuran (Dia. Poros)",
    shaftSpeed: "Kecepatan poros",
    bearingLoad: "Beban bantalan (Rata-rata)",
    quantityOfCoolingWater: "Jumlah air pendingin (Referensi)",
    temperatureOfCoolingWater: "Suhu air pendingin",
    documents: "Dokumen",
    documentsSubtitle: "Akses katalog produk dan manual untuk informasi detail",
    productCatalog: "Katalog Produk",
    productCatalogDescription: "Katalog lengkap dengan spesifikasi teknis dan detail",
    manualInstruction: "Petunjuk Manual",
    manualInstructionDescription: "Manual instalasi dan operasi untuk EVR",
    downloadPDF: "Unduh PDF"
  },
  
  // EVU - Water Lubricated Stern Tube Bearing
  evu: {
    title: "Water Lubricated Stern Tube Bearing - EVU",
    breadcrumb: "Water Lubricated Stern Tube Bearing - EVU",
    description1: "Bantalan Poli-Urethane \"EVU\" dikembangkan untuk sistem stern tube berpelumas air berdasarkan teknologi yang dikembangkan dalam pengalaman bantalan berpelumas air kami.",
    categoryValue: "Maritim, Bantalan Berpelumas Air",
    typeValue: "Water Lubricated Stern Tube Bearing",
    modelValue: "EVU",
    materialValue: "Senyawa Poli-Urethane",
    temperatureRangeValue: "-10°C hingga 60°C",
    maxPressureValue: "Hingga 1,5 MPa",
    applicationsValue: "Kapal Maritim, Sistem Propulsi Berpelumas Air",
    // Features section
    featuresTitle: "Fitur",
    featuresSubtitle: "Fitur utama dari Bantalan Poli-Urethane (EVU)",
    lowFriction: "1. Gesekan Rendah",
    lowFrictionDescription: "Dengan meratakan bagian bawah, kemampuan pembentukan film air ditingkatkan dan koefisien gesekan dalam penggunaan normal dapat lebih rendah dari bantalan karet dan sejenisnya. (1/10 dari bantalan karet dalam penggunaan normal)",
    lowWear: "2. Aus Rendah",
    lowWearDescription: "Menggunakan material Poli-Urethane dengan resistensi aus yang sangat baik. Dikonfirmasi memiliki resistensi aus 10 tahun atau lebih dalam tes evaluasi kami.",
    reductionOfSinglePartHit: "3. Pengurangan single-part hit",
    reductionOfSinglePartHitDescription: "Dengan menggunakan material Poli-Urethane yang fleksibel, beban terkonsentrasi di ujung AFT dapat dihindari.",
    bearingLength: "4. Panjang Bantalan",
    bearingLengthDescription: "Panjang bantalan dapat dibagi dua dari bantalan karet, karena resistensi tekanan ditingkatkan.",
    quickDelivery: "5. Pengiriman Cepat",
    quickDeliveryDescription: "Karena memiliki struktur tunggal Poli-Urethane, jika material tersedia, hanya pemrosesan yang diperlukan untuk produksi, sehingga memungkinkan untuk merespons waktu pengiriman singkat.",
    installMethod: "6. Metode Instalasi",
    installMethodDescription: "Menggunakan karakteristik Poli-Urethane, instalasi ke stern tube dengan cold fit.",
    // Documents section
    documentsTitle: "Dokumen",
    documentsSubtitle: "Akses katalog produk dan manual untuk informasi detail",
    productCatalog: "Katalog Produk",
    productCatalogDescription: "Katalog lengkap dengan spesifikasi teknis dan detail",
    manualInstruction: "Petunjuk Manual",
    manualInstructionDescription: "Manual instalasi dan operasi untuk EVU",
    downloadPDF: "Unduh PDF"
  },
  
  // EVU - Water Lubricated Stern Tube Bearing
  evuValveStemSeal: {
    title: "Water Lubricated Stern Tube Bearing - EVU",
    breadcrumb: "Water Lubricated Stern Tube Bearing - EVU",
    description1: "Segel batang katup EVU dirancang untuk memberikan kinerja penyegelan yang sangat baik untuk aplikasi katup mesin. Segel ini mencegah oli masuk ke ruang pembakaran melalui panduan katup sambil memungkinkan pelumasan yang tepat dari batang katup.",
    description2: "Diproduksi dengan material berkualitas tinggi dan rekayasa presisi, segel batang katup EVU menawarkan daya tahan dan keandalan yang superior. Segel dirancang untuk menahan variasi suhu ekstrem dan kondisi operasi yang keras dalam mesin modern. Proses manufaktur canggih Eagle Industry memastikan kualitas dan kinerja yang konsisten di semua produk EVU.",
    description3: "Seri EVU menampilkan desain kompak yang memungkinkan instalasi dan penggantian yang mudah. Segel ini kompatibel dengan berbagai aplikasi mesin dan memberikan efisiensi penyegelan optimal selama masa pakainya.",
    categoryValue: "Segel Batang Katup",
    modelValue: "Seri EVU",
    materialValue: "Fluoroelastomer Kelas Tinggi",
    temperatureRangeValue: "-40°C hingga 250°C",
    pressureRatingValue: "Hingga 5 MPa",
    applicationsValue: "Sistem Katup Mesin",
    features: {
      excellentOilResistance: "Resistensi oli yang sangat baik",
      superiorHeatResistance: "Resistensi panas yang superior",
      preciseDimensionalControl: "Kontrol dimensi yang presisi",
      enhancedDurability: "Daya tahan yang ditingkatkan"
    },
    noteText: "Catatan: Angka di atas menunjukkan kondisi terbaik dalam kasus individual dan mungkin berbeda sesuai dengan ukuran segel. Hubungi kami sebelum digunakan."
  },
  
  // Floating Seal
  floatingSeal: {
    title: "Floating Seal ES100 & ES764",
    breadcrumb: "Floating Seal ES100 & ES764",
    description1: "Segel untuk undercarriage mesin konstruksi (rol trek, penggerak akhir, as dan idler). Struktur sederhana yang terdiri dari O-ring dan cincin segel yang terbuat dari besi cor khusus. Segel optimal untuk undercarriage bulldozer dan ekskavator hidraulik yang sering terkena pasir, kotoran dan benda asing lainnya. ES764 menawarkan kemudahan dalam merancang dan memproduksi perumahan.",
    categoryValue: "Mesin, Undercarriage",
    sealedFluidValue: "Di dalam: pelumas, Di luar: pasir, kotoran dan lumpur",
    temperatureValue: "NBR: -40 hingga 100ºC, H-NBR: -30 hingga 130ºC, FKM: -10 hingga 200ºC",
    maximumCircumferentialVelocityValue: "MAKS. 2m/detik",
    pressureValue: "MAKS. 0,2 MPaG",
    shaftDiameterValue: "φ38～φ154mm",
    materialValue: "Cincin segel besi cor khusus, O-ring/gasket karet",
    applicationsValue: "Rol trek, penggerak akhir, as, idler, konveyor, mixer, mesin penggali",
    noteText: "Catatan: Angka di atas menunjukkan kondisi terbaik dalam kasus individual dan mungkin berbeda sesuai dengan ukuran segel. Hubungi kami sebelum digunakan.",
    // Feature translations
    simpleStructure: "Struktur Sederhana",
    simpleStructureDescription: "Segel mengambang adalah produk sederhana, yang terdiri dari dua komponen: cincin segel yang terbuat dari besi cor khusus dan komponen karet (O-ring/gasket). Dalam penggunaan, dua segel identik membentuk sepasang.",
    flexibleDesign: "Desain Fleksibel",
    flexibleDesignDescription: "Cincin segel, yang merupakan komponen geser, tidak kontak dengan poros karena ditopang oleh komponen karet, dan oleh karena itu mengikuti gerakan radial dan dorong poros dengan dekat.",
    durableMaterials: "Material Tahan Lama",
    durableMaterialsDescription: "Karena mereka dikembangkan untuk aplikasi slurry, cincin segel terbuat dari material yang sangat keras, tahan aus dan tahan korosi. Komponen karet menekan permukaan geser cincin segel dan juga berfungsi sebagai segel.",
    wideRangeOfApplications: "Rentang Aplikasi yang Luas",
    wideRangeOfApplicationsDescription: "Penggunaan utama segel mengambang termasuk rol crawler, penggerak perjalanan dan idler mesin konstruksi dan pertanian, dan juga untuk konveyor, mixer, dan berbagai mesin penggali. Dengan kata lain, mereka digunakan secara luas dalam aplikasi kecepatan relatif rendah yang terkena benda asing."
  },
  
  // Lip Seal
  lipSeal: {
    title: "Lip Seal Untuk Kompresor A/C",
    breadcrumb: "Lip Seal Untuk Kompresor A/C",
    description1: "Segelan poros berputar yang dirancang khusus untuk kompresor AC mobil",
    description2: "Desain asli Eagle Industry yang menampilkan kompaksi dan keandalan tinggi",
    description3: "Membantu menghilangkan kebocoran CFC yang menyebabkan pemanasan global",
    description4: "Terbuat dari karet yang cocok untuk menyegel CFC dan oli kulkas",
    description5: "Produksi massal dengan jalur perakitan otomatis penuh dan disuplai ke produsen kompresor di seluruh dunia",
    categoryValue: "Otomotif, Sistem A/C",
    typeValue: "Lip Seal",
    materialValue: "Senyawa Elastomer Khusus",
    temperatureRangeValue: "-40°C hingga 150°C",
    maxPressureValue: "Hingga 2,5 MPa",
    applicationsValue: "Kompresor A/C Otomotif, Sistem Pendingin",
    // Additional keys for lipSeal-details.js
    productTitle: "Lip Seal Untuk Kompresor A/C",
    descriptionParagraph1: "Ini adalah segelan poros berputar yang dirancang khusus untuk kompresor AC mobil. Desain asli Eagle Industry yang menampilkan kompaksi dan keandalan tinggi. Mereka membantu menghilangkan kebocoran CFC yang menyebabkan pemanasan global. Terbuat dari karet yang cocok untuk menyegel CFC dan oli kulkas. Produksi massal dengan jalur perakitan otomatis penuh dan disuplai ke produsen kompresor di seluruh dunia.",
    descriptionParagraph2: "Segel bibir direkayasa dengan presisi untuk memberikan kinerja optimal dalam sistem AC otomotif. Dengan material canggih dan desain inovatif, segel ini memastikan daya tahan dan efisiensi maksimal dalam mencegah kebocoran refrigeran sambil mempertahankan operasi poros kompresor yang halus.",
    descriptionParagraph3: "Segel bibir kami menjalani proses kontrol kualitas yang ketat untuk memenuhi standar internasional untuk komponen otomotif. Senyawa karet khusus yang digunakan dalam manufaktur menawarkan resistensi yang sangat baik terhadap berbagai refrigeran dan minyak kompresor, memastikan masa pakai yang lama bahkan dalam kondisi operasi ekstrem.",
    productInformation: "Informasi Produk",
    category: "Kategori",
    categoryValue: "Otomotif, Kompresor AC Mobil",
    sealedFluid: "Fluida yang disegel",
    sealedFluidValue: "R134a/R1234yf & Minyak kompresor",
    operatingTemperature: "Suhu Operasional",
    operatingTemperatureValue: "-40 hingga 150ºC",
    maximumCircumferentialVelocity: "Kecepatan sirkumferensial maksimum",
    maximumCircumferentialVelocityValue: "8 m/s (kira-kira 10.000 rpm)",
    fluidPressureRange: "Rentang Tekanan Fluida",
    fluidPressureRangeValue: "Saat berputar (ON): 0 hingga 0,7 MPaG, Saat diam (OFF): -760 mmHg hingga 3 MPaG",
    shaftDiameter: "Diameter poros",
    shaftDiameterValue: "12,7 hingga 20 mm",
    material: "Material",
    materialValue: "Senyawa karet khusus untuk resistensi CFC",
    applications: "Aplikasi",
    applicationsValue: "Kompresor AC otomotif untuk kendaraan penumpang dan komersial",
    inquireAboutThisProduct: "Inkuiri Tentang Produk Ini",
    noteText: "Catatan: Angka di atas menunjukkan kondisi terbaik dalam kasus individual dan mungkin berbeda sesuai dengan ukuran segel. Hubungi kami sebelum digunakan.",
    // Related products
    forAcCompressor: "untuk kompresor A/C",
    typeAMechanicalSeal: "Mechanical seal Tipe A",
    forWaterPump: "untuk Water Pump",
    eh795EH790: "EH795/EH790",
    forVariableDisplacementAcCompressor: "untuk Kompresor A/C Perpindahan Variabel",
    controlValve: "Katup pemutus udara",
    contact: "Kontak"
  },
  
  // Marine Ace Seal (MAS)
  mas: {
    title: "Marine Ace Seal (MAS)",
    breadcrumb: "Marine Ace Seal (MAS)",
    description1: "Kami adalah produsen terkemuka perangkat penyegelan poros stern tube di seluruh dunia dengan produk kami dipasang di lebih dari 30.000 kapal dengan tonase kotor 100 atau lebih. Marine Ace Seal (MAS) adalah segel stern berpelumas air yang baru kami kembangkan untuk kapal kecil dengan sistem penggerak langsung.",
    categoryValue: "Water Lubricated Stern Tube Seal",
    typeValue: "Segel Stern Berpelumas Air",
    modelValue: "MAS",
    materialValue: "Material Segel Kelas Maritim",
    temperatureRangeValue: "-5°C hingga 70°C",
    maxPressureValue: "Hingga 0,8 MPa",
    applicationsValue: "Kapal kecil dengan sistem penggerak langsung",
    shaftRange: "Rentang Poros",
    allowablePvValue: "Nilai PV yang Diizinkan",
    pressure: "Tekanan (P)",
    requiredCoolingWater: "Pendingin Air yang Diperlukan",
    coolingWaterTemperature: "Suhu Air Pendingin",
    shaftRotationSpeed: "V (Kecepatan rotasi poros)",
    variesByApplication: "Bervariasi sesuai aplikasi",
    noteText: "Catatan: Angka di atas menunjukkan kondisi terbaik dalam kasus individual dan mungkin berbeda sesuai dengan ukuran segel. Hubungi kami sebelum digunakan."
  },

  // MAS specific translations
    masFeaturedDescription: "Segel berpelumas air yang kompak dan berkinerja tinggi yang memiliki resistensi getaran dan kinerja penyegelan yang sangat baik.",
    masFeatures: {
      excellentVibrationResistance: "1. Resistensi getaran dan kinerja penyegelan yang sangat baik",
      excellentVibrationResistanceDescription: "Karena struktur segel ujung wajah yang terdiri dari cincin segel karet dan cincin pasangan baja tahan karat, ia mampu mengikuti getaran poros yang kompleks dan perpindahan sehingga menunjukkan kinerja penyegelan yang sangat baik.",
      excellentFollowabilityInAxialDirection: "2. Kemampuan mengikuti yang sangat baik dalam arah aksial",
      excellentFollowabilityInAxialDirectionDescription: "Karena penyegelan dicapai oleh cincin segel yang berputar pada kecepatan yang sama dengan poros dan struktur wajahnya yang membuat kontak dengan cincin pasangan stasioner sebagai penghenti, ia mampu menyerap semua gerakan aksial.",
      simpleAndRobustRubberHousingDesign: "3. Desain perumahan karet yang sederhana dan kuat",
      simpleAndRobustRubberHousingDesignDescription: "Diameter dalam perumahan dirancang ke standar tinggi yang sama seperti bantalan karet sehingga dapat menahan kontak dengan poros diturunkan. Karena area penyegelan tidak terpapar secara eksternal seperti kasus dengan segel mekanis, ia mampu menahan 'mekanikal shock' ke tingkat yang tinggi.",
      easyToInstall: "4. Mudah dipasang",
      easyToInstallDescription: "Ruang instalasi kompak dengan struktur yang hanya memerlukan selang air pendingin untuk disuplai. Struktur diperbaiki ke stern tube dengan cara dua hose bands membuatnya sederhana untuk dipasang.",
      excellentSlurryResistance: "5. Resistensi slurry yang sangat baik",
      excellentSlurryResistanceDescription: "Segel dapat diharapkan memiliki masa pakai yang lama bahkan dalam kondisi air kotor dengan tingkat sedimen tinggi seperti yang ditemukan di air dangkal dan sungai."
    },
    masSpecificationTable: {
      shaftRange: "Rentang Poros",
      allowablePvValue: "Nilai PV yang Diizinkan",
      requiredAmountOfCoolingWater: "Jumlah air pendingin yang diperlukan",
      temperatureOfCoolingWater: "Suhu air pendingin"
    },
  
  // O-Ring
  oRing: {
    title: "SUPERIOR O-Ring",
    breadcrumb: "SUPERIOR O-Ring",
    description1: "Material O-Ring yang baru dikembangkan dengan resistensi kimia yang lebih baik, generasi outgas rendah, dan resistensi panas ringan untuk industri proses semikonduktor.",
    description2: "SUPERIOR O-Ring kami direkayasa khusus untuk aplikasi semikonduktor dan kemurnian tinggi. Formulasi material canggih menyediakan resistensi kimia yang sangat baik dan sifat outgassing minimal.",
    description3: "Dikembangkan dengan teknologi mutakhir, O-Ring kami menawarkan kinerja superior dalam proses semikonduktor yang menuntut. Material menyediakan resistensi yang sangat baik terhadap berbagai bahan kimia sambil mempertahankan integritas penyegelan.",
    categoryValue: "Semikonduktor, Solusi Penyegelan",
    typeValue: "O-Ring",
    materialValue: "Elastomer Kelas Semikonduktor Canggih",
    temperatureRangeValue: "-50°C hingga 200°C",
    maxPressureValue: "Hingga 10,0 MPa",
    applicationsValue: "Peralatan Proses Semikonduktor, Aplikasi Kemurnian Tinggi",
    // Additional keys for oRing-details.js
    semiconductor: "Semikonduktor",
    semiconductorProcess: "Proses Semikonduktor",
    productTitle: "SUPERIOR O-Ring",
    descriptionParagraph1: "Seri \"SUPERIOR\" baru dikembangkan sebagai material O-Ring dengan resistensi kimia yang lebih baik, generasi outgas rendah, dan resistensi panas ringan terutama untuk industri proses semikonduktor.",
    descriptionParagraph2: "FKM dan VMQ untuk berbagai aplikasi dalam proses manufaktur semikonduktor tersedia. O-ring ini memberikan kinerja yang luar biasa dalam lingkungan semikonduktor yang menuntut di mana presisi dan keandalan kritis.",
    descriptionParagraph3: "Seri SUPERIOR menunjukkan resistensi yang sangat baik untuk plasma dan bahan kimia, menjadikannya ideal untuk kondisi keras yang dihadapi dalam manufaktur semikonduktor. Dengan generasi outgas rendah dan kontinuitas resistensi baik terhadap fototermal yang dihasilkan dalam proses manufaktur semikonduktor, o-ring ini mempertahankan integritas dan kinerja penyegelannya bahkan dalam kondisi ekstrem.",
    productInformation: "Informasi Produk",
    category: "Kategori",
    categoryValue: "Packing, Gasket",
    productSeries: "Seri Produk",
    productSeriesValue: "SUPERIOR",
    material: "Material",
    materialValue: "FKM dan VMQ",
    keyFeatures: "Fitur Utama",
    keyFeaturesValue: "Resistensi kimia, generasi outgas rendah",
    specialProperties: "Properti Khusus",
    specialPropertiesValue: "Resistensi plasma, resistensi panas ringan",
    applications: "Aplikasi",
    applicationsValue: "Industri proses semikonduktor",
    inquireAboutThisProduct: "Inkuiri Tentang Produk Ini",
    productFeatures: "Fitur Produk",
    featuresInfo: "Informasi tentang fitur SUPERIOR O-Ring.",
    materialOptions: "Opsi Material",
    materialOptionsValue: "FKM dan VMQ untuk berbagai aplikasi dalam proses manufaktur semikonduktor",
    plasmaResistance: "Resistensi Plasma",
    plasmaResistanceValue: "Resistensi yang sangat baik untuk plasma",
    chemicalResistance: "Resistensi Kimia",
    chemicalResistanceValue: "Resistensi yang sangat baik untuk bahan kimia",
    outgasGeneration: "Generasi Outgas",
    outgasGenerationValue: "Generasi outgas kecil",
    photoThermalResistance: "Resistensi Fototermal",
    photoThermalResistanceValue: "Kontinuitas resistensi baik terhadap fototermal yang dihasilkan dalam proses manufaktur semikonduktor",
    noteText: "Catatan: Seri SUPERIOR dikembangkan khusus untuk aplikasi industri proses semikonduktor dengan resistensi kimia superior dan generasi outgas rendah.",
    // Related products
    forAcCompressor: "untuk kompresor A/C",
    typeAMechanicalSeal: "Mechanical seal Tipe A",
    forWaterPump: "untuk Water Pump",
    eh795EH790: "EH795/EH790",
    forVariableDisplacementAcCompressor: "untuk Kompresor A/C Perpindahan Variabel",
    controlValve: "Katup Kontrol",
    contact: "Kontak"
  },
  
  // Reed Valve
  reedValve: {
    title: "Reed Valve",
    breadcrumb: "Reed Valve",
    description1: "Dirancang untuk digunakan dalam mesin sepeda motor empat tak untuk kontrol emisi (pasokan udara sekunder).",
    description2: "Secara substansial mengurangi emisi karbon monoksida (CO) dan hidrokarbon (HC) untuk mengurangi polusi udara.",
    description3: "Reed Valve yang kompak dan ringan ini dipasang di ruang terbatas memastikan aliran besar.",
    description4: "Katup yang sangat responsif untuk mode kecepatan tinggi.",
    description5: "Reed valve kami direkayasa dengan presisi untuk memberikan kinerja optimal dalam mesin sepeda motor. Dengan material canggih dan desain inovatif, katup ini memastikan daya tahan dan efisiensi maksimal dalam mengontrol emisi sambil mempertahankan operasi mesin yang halus.",
    productTitle: "Reed Valve",
    categoryValue: "Otomotif, Mesin Sepeda Motor",
    applicationValue: "Mesin sepeda motor empat tak",
    functionValue: "Kontrol emisi (pasokan udara sekunder)",
    temperatureRangeValue: "-20 hingga 140°C",
    vibrationDurabilityValue: "20 G pada 200Hz untuk 10^7 siklus",
    materialValue: "Baja tahan karat kelas tinggi",
    applicationsValue: "Sistem kontrol emisi sepeda motor",
    productSpecification: "Contoh Spesifikasi Produk",
    specificationInfo: "Informasi tentang spesifikasi Produk.",
    temperature: "Suhu",
    vibrationDurability: "Daya tahan getaran",
    noteText: "Catatan: Angka di atas menunjukkan beberapa contoh. Hubungi kami ketika Anda mempertimbangkan untuk melakukan pembelian.",
    // Features section
    features: "Fitur",
    featuresSubtitle: "Fitur utama dari Reed Valves untuk Water Pump",
    compactLightweightDesign: "Desain Kompak dan Ringan",
    compactLightweightDesignDescription: "Reed Valve yang kompak dan ringan ini dipasang di ruang terbatas memastikan aliran besar.",
    highlyResponsive: "Sangat Responsif",
    highlyResponsiveDescription: "Katup yang sangat responsif untuk mode kecepatan tinggi.",
    // Related products
    forAcCompressor: "untuk kompresor A/C",
    typeAMechanicalSeal: "Mechanical seal Tipe A",
    forWaterPump: "untuk Water Pump",
    eh795EH790: "EH795/EH790",
    forVariableDisplacementAcCompressor: "untuk Kompresor A/C Perpindahan Variabel",
    controlValve: "Katup Kontrol",
    contact: "Kontak"
  },
  
  // Rudder Seal
  rudderSeal: {
    title: "Rudder Seal (RSC)",
    breadcrumb: "Rudder Seal (RSC)",
    description1: "Produksi segel kemudi dengan segelan bibir self-lubricating berkinerja tinggi yang dirancang untuk dipasang di atas bantalan kemudi untuk mencegah masuknya air laut ke lambung. Diproduksi dari karet khusus, memberikan masa pakai aus yang lama tanpa perlu penyesuaian berkala, beroperasi dengan lebih sedikit hambatan dan mengurangi aus poros atau liner.",
    advantagesDescription: "Keunggulan utama dan manfaat dari Rudder Seal",
    advantage1: {
      title: "1. Desain Self-Lubricating Berkinerja Tinggi",
      description: "Diproduksi dari senyawa karet khusus yang memberikan sifat self-lubricating yang sangat baik, mengurangi gesekan dan memperpanjang masa pakai."
    },
    advantage2: {
      title: "2. Perlindungan Superior Terhadap Masuknya Air",
      description: "Dirancang untuk dipasang di atas bantalan kemudi untuk secara efektif mencegah masuknya air laut ke lambung, melindungi komponen kritis."
    },
    advantage3: {
      title: "3. Masa Pakai Aus yang Lama",
      description: "Formulasi karet khusus memastikan masa pakai aus yang diperpanjang tanpa perlu penyesuaian berkala, mengurangi kebutuhan perawatan."
    },
    advantage4: {
      title: "4. Mengurangi Hambatan dan Aus Poros",
      description: "Beroperasi dengan lebih sedikit hambatan dan secara signifikan mengurangi aus poros/liner, meningkatkan efisiensi keseluruhan dan memperpanjang umur komponen."
    },
    advantage5: {
      title: "5. Mudah dipasang",
      description: "Proses instalasi yang sederhana yang menghemat waktu dan mengurangi biaya tenaga kerja."
    },
    advantage6: {
      title: "6. Tidak memerlukan perawatan",
      description: "Desain tanpa perawatan yang menghilangkan kebutuhan akan layanan berkala."
    },
    manualDescription: "Manual instalasi dan operasi untuk Rudder Seal",
    relatedProductsDescription: "Produk lainnya dalam kategori Water Lubricated Stern Tube Seal",
    productInformation: "Informasi Produk",
    category: "Kategori",
    sealedFluid: "Fluida yang disegel",
    operatingTemperature: "Suhu Operasional",
    maximumCircumferentialVelocity: "Kecepatan sirkumferensial maksimum",
    fluidPressureRange: "Rentang Tekanan Fluida",
    shaftDiameter: "Diameter poros",
    material: "Material",
    applications: "Aplikasi",
    categoryValue: "Maritim, Segel Kemudi",
    sealedFluidValue: "Air laut",
    operatingTemperatureValue: "-20°C hingga 120°C",
    maximumCircumferentialVelocityValue: "15 m/s (kira-kira 5.000 rpm)",
    fluidPressureRangeValue: "0 hingga 0,5 MPaG",
    shaftDiameterValue: "100 hingga 800 mm",
    materialValue: "Senyawa karet khusus untuk aplikasi maritim",
    applicationsValue: "Kapal maritim, kapal komersial, kapal pesisir",
    typesAvailable: "Tipe yang Tersedia",
    cxType: "Tipe CX: Model standar",
    dxType: "Tipe DX: Dengan segel siaga tambahan",
    axType: "Tipe AX: Model bebas polusi",
    evaType: "Tipe EVA: Dilengkapi dengan segel wajah",
    inquireAboutThisProduct: "Inkuiri Tentang Produk Ini",
    noteText: "Catatan: Angka di atas menunjukkan kondisi terbaik dalam kasus individual dan mungkin berbeda sesuai dengan ukuran segel. Hubungi kami sebelum digunakan.",
    // Related products
    forAcCompressor: "untuk kompresor A/C",
    typeAMechanicalSeal: "Mechanical seal Tipe A",
    forWaterPump: "untuk Water Pump",
    eh795EH790: "EH795/EH790",
    forVariableDisplacementAcCompressor: "untuk Kompresor A/C Perpindahan Variabel",
    controlValve: "Katup Kontrol",
    contact: "Kontak"
  },

  // Common section titles
    features: "Fitur",
    advantages: "Keunggulan",
    featuresDescription: "Fitur utama dari {product}",
    specification: "Spesifikasi",
    specificationDescription: "Spesifikasi teknis dari {product}",
    documents: "Dokumen",
    documentsDescription: "Akses katalog produk dan manual untuk informasi detail",
    productCatalog: "Katalog Produk",
    productCatalogDescription: "Katalog lengkap dengan spesifikasi teknis dan detail",
    manualInstruction: "Petunjuk Manual",
    downloadPDF: "Unduh PDF",
  
  // Service Engineer
  serviceEngineer: {
    title: "Service Engineer",
    breadcrumb: "Service Engineer",
    description1: "Layanan teknik profesional untuk sistem penyegelan kapal Anda. Kami menyediakan service engineer yang sangat terampil dan berpengalaman untuk menangani semua aspek penyegelan maritim.",
    description2: "Tim rekayasa layanan kami menawarkan dukungan komprehensif untuk sistem penyegelan maritim. Dengan pengalaman luas dan keahlian teknis, kami menyediakan solusi untuk berbagai tantangan penyegelan dalam aplikasi maritim.",
    description3: "Service engineer kami dilatih untuk menangani semua aspek sistem penyegelan maritim, dari instalasi hingga pemeliharaan dan pemecahan masalah. Kami memastikan kinerja dan keandalan optimal dari solusi penyegelan Anda.",
    categoryValue: "Layanan Maritim, Dukungan Teknis",
    serviceType: "Layanan Teknik Profesional",
    expertise: "Sistem Penyegelan Maritim",
    serviceAreas: "Instalasi, Pemeliharaan, Pemecahan Masalah",
    availability: "Jaringan Layanan Global",
    applicationsValue: "Kapal Maritim, Kapal, Platform Lepas Pantai",
    // Additional keys for serviceEngineer-details.js
    serviceInformation: "Informasi Layanan",
    serviceTypeValue: "Dukungan Teknis & Pemeliharaan",
    serviceAreaValue: "Cakupan Seluruh Dunia",
    responseTimeValue: "24-48 jam (Darurat)",
    serviceAvailabilityValue: "Dukungan 24/7",
    specializationValue: "Sistem Penyegelan Maritim",
    serviceCentersValue: "Jaringan Global",
    contactServiceEngineer: "Hubungi Service Engineer",
    globalServiceNetwork: "Jaringan Layanan Global",
    ourServiceEngineersAvailableWorldwide: "Tim rekayasa layanan kami tersedia di seluruh dunia",
    noteText: "Catatan: Service engineer kami tersedia 24/7 untuk dukungan darurat. Hubungi kami untuk bantuan segera.",
    contactServiceEngineerSection: "Hubungi Service Engineer",
    pleaseContactUsViaOurEmailForm: "Silakan hubungi kami melalui formulir email kami untuk dukungan teknis",
    // Hardcoded strings that need translation
    professionalEngineeringServices: "Layanan teknik profesional untuk sistem penyegelan kapal Anda.",
    weProvideHighlySkilled: "Kami menyediakan service engineer yang sangat terampil dan berpengalaman untuk menangani semua aspek penyegelan maritim — dari perekatan dan perakitan hingga inspeksi dan supervisi di lokasi.",
    withDeepUnderstanding: "Dengan pemahaman mendalam tentang lingkungan maritim dan kepatuhan pada standar industri tertinggi, kami memastikan setiap segel dipasang dengan presisi dan memberikan kinerja optimal untuk mencegah kebocoran, meningkatkan efisiensi, dan memperpanjang suku cadang peralatan.",
    expertServiceEngineers: "Service engineer ahli menyediakan instalasi dan pemeliharaan profesional untuk sistem penyegelan maritim di seluruh dunia.",
    features: "Fitur",
    keyFeaturesAndBenefits: "Fitur utama dan manfaat dari solusi Service Engineer kami",
    professionalInstallationServices: "1. Layanan Instalasi Profesional",
    professionalInstallationDescription: "Service engineer yang sangat terampil kami berspesialisasi dalam instalasi sistem penyegelan maritim yang presisi, memastikan kinerja optimal dan umur panjang peralatan Anda.",
    expertBondingAndAssembly: "2. Perekatan dan Perakitan Ahli",
    expertBondingDescription: "Dengan pengalaman luas dalam teknologi penyegelan maritim, insinyur kami menangani proses perekatan dan perakitan yang kompleks dengan perhatian detail yang teliti.",
    comprehensiveInspectionServices: "3. Layanan Inspeksi Komprehensif",
    comprehensiveInspectionDescription: "Inspeksi menyeluruh sistem penyegelan untuk mengidentifikasi potensi masalah sebelum menjadi masalah, memastikan operasi yang andal dan mencegah downtime yang mahal.",
    onSiteSupervision: "4. Supervisi di Lokasi",
    onSiteSupervisionDescription: "Service engineer kami menyediakan supervisi ahli di lokasi untuk operasi penyegelan kritis, memastikan kepatuhan dengan standar industri dan spesifikasi produsen.",
    serviceInformationDetails: "Informasi Layanan",
    detailsAboutOurService: "Detail tentang penawaran service engineer kami",
    contactUs: "Hubungi Kami",
    requestService: "Permintaan Layanan",
    marineIndustryProducts: "Produk industri maritim",
    // Region translations
    asia: "Asia",
    asiaLocations: "Jepang (Tokyo, Kobe, Hiroshima)<br>Cina, Singapura, Taiwan, Korea Selatan<br>Indonesia, Filipina, Thailand, India",
    europe: "Eropa",
    europeLocations: "Inggris, Jerman, Yunani<br>Norwegia, Swedia, Denmark, Finlandia<br>Italia, Prancis, Portugal, Polandia, Belanda<br>Rusia, Bulgaria, Spanyol",
    northAmerica: "Amerika Utara",
    northAmericaLocations: "AS, Kanada, Meksiko, Laut Karibia",
    southAmerica: "Amerika Selatan",
    southAmericaLocations: "Chili, Brasil",
    oceania: "Oseania",
    oceaniaLocations: "Australia",
    middleEast: "Timur Tengah",
    middleEastLocations: "UAE & Teluk",
    // Related products
    forAcCompressor: "untuk kompresor A/C",
    typeAMechanicalSeal: "Mechanical seal Tipe A",
    forWaterPump: "untuk Water Pump",
    eh795EH790: "EH795/EH790",
    forVariableDisplacementAcCompressor: "untuk Kompresor A/C Perpindahan Variabel",
    controlValve: "Katup Kontrol",
    contact: "Kontak",
    
    
    
    // Common descriptions
    otherProductsInCategory: "Produk lainnya dalam kategori {category}",
    industrial: "Industri",
    hydraulicComponents: "Komponen Hidraulik",
    machinery: "Mesin",
  }
};